// @flow
import {omitBy} from 'lodash';

/**
 *
 * @param {object} obj - object
 * @param {array} values - array of values to match in obj
 * @returns {boolean} - true if obj contains any of the keys; false otherwise
 */
export const contains = (obj: Object, values: Array<string>): boolean => {
    const map = new Map(Object.entries(obj));
    let hasValue = false;

    values.map((v) => {
        if (map.has(v)) {
            hasValue = true;
        }
    });
    return hasValue;
};

export const omitFalsy = (obj: Object): Object => {
    return omitBy(obj, (i) => !i);
};

export function isDifferent(obj1: any, obj2: any): boolean {
    return JSON.stringify(obj1) !== JSON.stringify(obj2);
}

/**
 * Determine if the values in an object have falsy values if the type is a string
 */
export function hasFalsyValues(obj: Object) {
    for (const key in obj) {
        /* istanbul ignore else */
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (obj[key] === 'false' || obj[key] === '0' || !obj[key]) {
                return true;
            }
        }
    }

    return false;
}
